import type { LinksFunction } from 'react-router'

import reset from '~/styles/reset.css?url'
import variables from '~/styles/variables.css?url'
import typographyNext from '~/styles/typography-next.css?url'
import page from '~/styles/page.css?url'
import error from '~/styles/pages/error.css?url'
import home from '~/styles/pages/home.css?url'

// Core site layout
import header from './header/header.css?url'
import stack from './stack/stack.css?url'
import button from './button/button.css?url'
import carouselButtonNext from './carousel-button-next/carousel-button-next.css?url'
import carouselRail from './carousel-rail/carousel-rail.css?url'
import linkCtaNext from './link-cta-next/link-cta-next.css?url'
import disclosure from '../components/disclosure/disclosure.css?url'
import footerCta from './footer-cta/footer-cta.css?url'
import footer from './footer/footer.css?url'
import flash from './flash/flash.css?url'
import squaredIcon from './squaredIcon/squaredIcon.css?url'
import navCard from './navCard/navCard.css?url'
import linkArrow from './link-arrow/link-arrow.css?url'
import { navRasterIconUrls } from './icons/nav-icon-assets'

const globalStyles: LinksFunction = () => [
  { rel: 'stylesheet', href: variables },
  { rel: 'stylesheet', href: reset },
  { rel: 'stylesheet', href: typographyNext },
  { rel: 'stylesheet', href: page },
]

/**
 * Components user across the site broadly and needed to accomplish
 * our unified site layout. These should be broadly imported by the
 * root loader
 */
export const rootLinks: LinksFunction = () => [
  ...globalStyles(),
  { rel: 'preload', href: home, as: 'style' },
  /**
   * Vite inlines the smaller nav icons as `data:` URIs. Preloading those is a
   * no-op — the bytes are already in the document — and ~70KB of base64 in
   * `<head>` delays the preload scanner reaching the stylesheets below.
   */
  ...navRasterIconUrls
    .filter((href) => !href.startsWith('data:'))
    .map((href) => ({
      rel: 'preload',
      href,
      as: 'image',
    })),
  { rel: 'stylesheet', href: error },
  { rel: 'stylesheet', href: button },
  { rel: 'stylesheet', href: carouselButtonNext },
  { rel: 'stylesheet', href: carouselRail },
  { rel: 'stylesheet', href: linkCtaNext },
  { rel: 'stylesheet', href: flash },
  { rel: 'stylesheet', href: footerCta },
  { rel: 'stylesheet', href: footer },
  { rel: 'stylesheet', href: disclosure },
  { rel: 'stylesheet', href: header },
  // The header lays out with Stack; error boundaries render it without a layout route.
  { rel: 'stylesheet', href: stack },
  { rel: 'stylesheet', href: squaredIcon },
  { rel: 'stylesheet', href: navCard },
  { rel: 'stylesheet', href: linkArrow },
]
